<template>
  <div>
  <div id="movelist-container" :key="moveListTrigger">
    <div v-for="item in resultsData" v-bind:key="item.san">
      <div class="movelist-row" v-bind:class="hoverClassObject">
        <div class="movelist-checkbox">
            <input  type="checkbox" value="" 
                  @change="onCheckboxChange($event,item.index)"
                  v-model="item.selected">
        </div>

        <!-- SAN -->
        <div class="movelist-text movelist-text-left" @click="onCheckboxChange($event,item.index)">
              {{ (item.san == "total") ? t("total") : item.san }}
        </div>
        
        <!-- game count total -->
        <div class="movelist-text movelist-text-right" @click="onClickMove(item.index)">
                {{ item.total }}</div>

        <!-- weighted score -->
        <div class="movelist-text movelist-text-right" @click="onClickMove(item.index)">
                {{ item.weightedScores[(Number(props.moveNumber) - 9) / 3] }}</div>

        <!-- compare game count -->
        <div class="movelist-text movelist-text-right movelist-compare" 
                    @click="onClickMove(item.index)">
                {{ item.totalCompare }}</div>

        <!-- compare weighted score -->
        <div class="movelist-text movelist-text-right movelist-compare" 
                    @click="onClickMove(item.index)">
                {{ item.weightedScoresCompare[(Number(props.moveNumber) - 9) / 3] }}</div>

      </div>
      
      <hr v-if="item.index == eighty" class="movelist-eighty-line">
    </div>
  </div>
  </div>
</template>


<script setup>

import WinLossBar from './WinLossBar.vue'
import { computed } from "@vue/reactivity"
import { ref , onBeforeUpdate } from 'vue'
import { watch } from "vue";
import { useConnectionStore } from '@/stores/connectionStore';
import { t } from '@/composables/translateText.js'

const props = defineProps({
  resultsData : Array,
  moveNumber : {
      type : Number,
      default : 15
    },
    moveListTrigger : {
        type : Number,
        default : 0
    },
  eighty : {
    type : Number,
    default : -100
  }
})

const emit = defineEmits(['checkbox-click'])

const connectionStore = useConnectionStore()

const isDark = ref(connectionStore.getDarkmode != "" && connectionStore.getDarkmode != "light") 

const hoverClassObject = (isDark.value) ? "dark-hover-mode" : "light-hover-mode"


//console.log("******************* ShowCHeck in setup")

const moveListTrigger = computed({
     get() {
       return props.moveListTrigger
     }
   })

const showScores = computed({
    get() {
      return props.showScores
    }
  })

  const showCheckboxes = computed({
    get() {
      return props.showCheckboxes
    }
  })

  const showEmails = computed({
    get() {
      return props.showEmails
    }
  })

const scrollToBottomTrigger = computed({
    get() {
      return props.scrollToBottomTrigger
    }
  })

  watch(moveListTrigger, (newVal,oldVal) => {
  })


function onClickMove(index) {
  //console.log("**** on move click",index)
  //emit("movelist-click",index)
  props.resultsData[index].selected = !props.resultsData[index].selected 
  emit("checkbox-click",{index : index, flag : props.resultsData[index].selected})
}

function onCheckboxChange(event,index) {
  //console.log("***** on checkbox change", index)
  //console.log(" click item ",props.resultsData[index])
  //console.log(" click flag ",props.resultsData[index].selected)

  emit("checkbox-click",{index : index, flag : props.resultsData[index].selected})
}

onBeforeUpdate(() => {

})

</script>

<style scoped>

.movelist-row {
  line-height: 1.5em;
  /*border-bottom: #d3dfe1 solid 1px;*/
  /*border-bottom: #286a6c solid 1px;*/
}

/* https://stackoverflow.com/questions/46551925/vuejs-v-bindstyle-hover */

.light-hover-mode {
  border-bottom: #d3dfe1 solid 1px;
}
.light-hover-mode:hover {
  background: #d3dfe1;
}

.dark-hover-mode {
  border-bottom: #286a6c solid 1px;
}

.dark-hover-mode:hover {
  background: #286a6c ;
}

.movelist-text {
  display: inline-block;
  width : 17%;
  bottom : 3px;
  position : relative;
}

.movelist-text-right {
  text-align: right;
}

.movelist-text-left {
  text-align: left;
}

.movelist-eighty-line {
  height : 5px;
  background : rgb(13,110,253)
}

.movelist-checkbox {
    border-radius: 0.25em;
    display: inline-block;
  width : 20px;
  bottom : 3px;
  position : relative;
}

.movelist-checkbox:checked {
    background-color: #0d6efd;
    border-color: #0d6efd;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3E%3C/svg%3E");
}

.movelist-checkmark-dark {
  color : white;
}

.movelist-checkmark-light {
  color : dark;
}

.movelist-compare {
  font-style:italic;
  color: #4c6ca0;
}
</style>